import React from 'react';
import './image-section.scss';
import AppImage from '../../../../common/features/image';

function ImageContainer({ image, imgSize = 'sm' }) {
    
    return (
        <div className="article-img-container">
            {imgSize === 'sm' ? (
                <AppImage className='article-img-sm' src={image} alt="Image-Section" title='Image-Section' />
            ) : imgSize === 'md' ?  (<AppImage className='article-img-md' src={image} alt="Image-Section" title='Image-Section' /> ): ( <AppImage className='article-img-lg' src={image} alt="Image-Section" title='Image-Section' />)}
        </div>
    )
}

export default React.memo(ImageContainer);